// @ts-ignore
import createPersistedState from 'vuex-persistedstate';
import { cloneDeep } from 'lodash';

export default createPersistedState({
    key:'pdaPersistence',
    storage: window.localStorage,
    reducer: (vuexState) => {
        // @ts-ignore
        // let backUrl =cloneDeep(vuexState.backUrl)
        // return {backUrl}
        return {}
    }
});
